import { Textarea } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

import { useInvoiceFormContext } from '../InvoiceForm.context';

export const CommentField = () => {
  const { t } = useTranslation();
  const form = useInvoiceFormContext();

  return (
    <Textarea
      {...form.getInputProps('comment')}
      placeholder={t(i18nKeys.INVOICING.CREATE.NOTES_COMMENTS)}
      size="xs"
      w="100%"
      maw={400}
      rows={6}
    />
  );
};
